import utils from '../../services/utils';
import axiosApi from '../../services/inteceptor';

const API_USER_INFO = `${utils.svcUrl()}user-info`;
const API_COURSE_INFO = `${utils.svcUrl()}course`;

const initialState = {
  fetchSegmentLoader: false,
  setReminderLoader: false,
  emailUpdateLoader: false,
  updateSegmentLoader: false,
  cronNotificationLoader: false,
  cronNotification: '',
  tempNotification: '',
};

const mutations = {
  SET_SEGMENT_LOADER(state, payload) {
    state.fetchSegmentLoader = payload;
  },
  SET_REMINDER_LOADER(state, payload) {
    state.setReminderLoader = payload;
  },
  SET_UPDATE_EMAIL_LOADER(state, payload) {
    state.emailUpdateLoader = payload;
  },
  SET_UPDATE_SEGMENT_LOADER(state, payload) {
    state.updateSegmentLoader = payload;
  },
  GET_CRON_NOTIFICATION(state, payload) {
    state.cronNotificationLoader = payload?.loader;
    state.cronNotification = payload?.data;
  },
  SET_TEMP_NOTIFICATION(state, payload) {
    state.tempNotification = payload;
  },
};

/**
 * *** userId = member _id
 * creatorId = creator or admin userId (provided by google)
 */
const actions = {
  getCronNotification: async ({ commit, state }) => {
    try {
      commit('GET_CRON_NOTIFICATION', { loader: true, data: state.cronNotification });
      const response = await axiosApi.get(`${API_USER_INFO}/cron-notification`);
      commit('GET_CRON_NOTIFICATION', { loader: false, data: response?.data?.message });
      return response?.data;
    } catch (error) {
      commit('GET_CRON_NOTIFICATION', { loader: false });
      console.log(error, error?.response);
      throw error;
    }
  },
  fetchMemberSegmentList: async ({ commit, rootState }, { userId, creatorId = rootState?.user?.uid }) => {
    try {
      commit('SET_SEGMENT_LOADER', true);
      const response = await axiosApi.get(`${API_USER_INFO}/enrolled-student/segment-list/${userId}/${creatorId}`);
      commit('SET_SEGMENT_LOADER', false);
      return response;
    } catch (error) {
      commit('SET_SEGMENT_LOADER', false);
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
  updateDmList: async () => {
    try {
      const response = await axiosApi.get(`${API_USER_INFO}/update/dmList`);
      return response;
    } catch (error) {
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
  setReminder: async ({ commit }, payload) => {
    try {
      commit('SET_REMINDER_LOADER', true);
      const response = await axiosApi.post(`${API_USER_INFO}/reminder`, payload);
      commit('SET_REMINDER_LOADER', false);
      return response.data;
    } catch (error) {
      console.log(error, error?.response);
      commit('SET_REMINDER_LOADER', false);
      throw Error(error?.response?.data?.message);
    }
  },
  clearReminder: async ({ commit }, payload) => {
    try {
      commit('SET_REMINDER_LOADER', true);
      const response = await axiosApi.put(`${API_USER_INFO}/reminder`, payload);
      commit('SET_REMINDER_LOADER', false);
      return response.data;
    } catch (error) {
      console.log(error, error?.response);
      commit('SET_REMINDER_LOADER', false);
      throw Error(error?.response?.data?.message);
    }
  },
  updateEmail: async ({ commit }, payload) => {
    try {
      commit('SET_UPDATE_EMAIL_LOADER', true);
      const response = await axiosApi.put(`${API_USER_INFO}/update/email`, payload);
      commit('SET_UPDATE_EMAIL_LOADER', false);
      return response.data;
    } catch (error) {
      console.log(error, error?.response);
      commit('SET_UPDATE_EMAIL_LOADER', false);
      throw error;
    }
  },
  updateSegmentFromEngagement: async () => {
    try {
      const response = await axiosApi.put(`${API_COURSE_INFO}/update/segment/egagement`);
      return response.data;
    } catch (error) {
      console.log(error, error?.response);
      throw error;
    }
  },
  changeButtonPossition: async (_, payload) => {
    console.log(payload);
    const response = await axiosApi.put(`${API_USER_INFO}/change/buttonPosition`, payload);
    return response.data;
  },
  changeAutoLike: async (_, payload) => {
    const response = await axiosApi.put(`${API_USER_INFO}/change/autoLike`, payload);
    return response.data;
  },
  handleClearDmsQueue: async () => {
    try {
      const response = await axiosApi.delete(`${API_USER_INFO}/clear/dms`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  handleClearReplyQueue: async () => {
    try {
      const response = await axiosApi.delete(`${API_USER_INFO}/clear/reply`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default {
  state: initialState,
  mutations,
  actions,
};
